import { useAppDispatch } from 'store/store';
import { setIsLoggedIn } from 'features/auth/authSlice';

export const useWelcomeStep = () => {
  const appDispatch = useAppDispatch();

  /** Submits the welcome step. */
  const submit = () => {
    appDispatch(setIsLoggedIn(true));
  };

  return {
    /** Submits the welcome step. */
    submit,
  };
};
